import React from 'react';
import FiberManualRecordRoundedIcon from '@mui/icons-material/FiberManualRecordRounded';
import { COLOR } from '@src/styles/color';
import {
  ItemContainer,
  BulletWrapper,
  ItemText,
  BoxContainer,
} from './index.style';

const Bullet = () => (
  <FiberManualRecordRoundedIcon
    sx={{ width: 10, height: 10, color: COLOR.indigo[64], borderRadius: '50%' }}
  />
);

const DetailsBoxItem = ({ children }) => (
  <ItemContainer>
    <BulletWrapper>
      <Bullet />
    </BulletWrapper>
    <ItemText>{children}</ItemText>
  </ItemContainer>
);

const DetailsBox = ({ children }) => <BoxContainer>{children}</BoxContainer>;

DetailsBox.Item = DetailsBoxItem;
DetailsBox.Bullet = Bullet;

export default DetailsBox;
